"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = tslib_1.__importDefault(require("react"));
const prop_types_1 = tslib_1.__importDefault(require("prop-types"));
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const Switch_1 = tslib_1.__importDefault(require("../switch/Switch"));
const TreeOption = props => {
    const { isChecked, className, label, onChange } = props, remainingProps = tslib_1.__rest(props, ["isChecked", "className", "label", "onChange"]);
    const optionClasses = (0, classnames_1.default)('TreeOption', 'display-flex', 'justify-content-start', 'align-items-center', 'gap-10', 'cursor-pointer', className);
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({}, remainingProps, { className: optionClasses, onClick: onChange }, { children: [(0, jsx_runtime_1.jsx)("span", Object.assign({ className: 'flex-1-1' }, { children: label })), (0, jsx_runtime_1.jsx)("span", Object.assign({ className: 'pointer-events-none scale-80' }, { children: (0, jsx_runtime_1.jsx)(Switch_1.default, { keyName: 'TreeOption-switch', checked: isChecked }) }))] })));
};
TreeOption.displayName = 'TreeOption';
TreeOption.defaultProps = {
    isChecked: false,
    onChange: () => { },
};
TreeOption.propTypes = {
    isChecked: prop_types_1.default.bool,
    onChange: prop_types_1.default.func,
    label: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.node]).isRequired,
    className: prop_types_1.default.string,
};
exports.default = TreeOption;
